package com.karawek.core.auth.api

enum class AuthCredentialType {
    SessionJwt,
    SessionToken,
}